import React from "react";

// Admin Imports
import MainDashboard from "views/admin/default";

// Auth Imports
import SignIn from "views/auth/SignIn";
import SignUp from "views/auth/SignUp";

// Icon Imports
import { MdHome, MdBarChart, MdLock } from "react-icons/md";

import RaiseComplaint from "views/user/raise-complaint";
import { GrCompliance } from "react-icons/gr";
import AccountsList from "views/super-admin/accounts/AccountsList";
import ForgotPassword from "views/auth/ForgotPassword";
import ResetPassword from "views/auth/ResetPassword";
import AddNewAccount from "views/super-admin/accounts/AddNewAccount";
import EditAccount from "views/super-admin/accounts/EditAccount";
import ComplaintList from "views/user/complaints/ComplaintList";

import { BsTable } from "react-icons/bs";
import EditComplaint from "views/user/complaints/EditComplaints";
import ViewComplaints from "views/user/complaints/ViewComplaints";
import { IoMdOptions } from "react-icons/io";
import ChangePassword from "views/user/profile/ChangePassword";

const routes = [
  {
    name: "Dashboard",
    layout: "/admin",
    path: "dashboard",
    icon: <MdHome className="h-6 w-6" />,
    component: <MainDashboard />,
    show: true,
  },
  // {
  //   name: "Upload Master Image",
  //   layout: "/admin",
  //   path: "upload-master-image",
  //   icon: <RiImageAddLine className="h-6 w-6" />,
  //   component: <UploadMainImage />,
  //   secondary: true,
  //   show: true,
  // },
  // {
  //   name: "Create Entity",
  //   layout: "/admin",
  //   path: "create-entity",
  //   icon: <IoMdOptions className="h-6 w-6" />,
  //   component: <CreateEntity />,
  //   secondary: true,
  //   show: true,
  // },
  // {
  //   name: "View Entity",
  //   layout: "/admin",
  //   path: "view-entity",
  //   icon: <TbEyeCheck className="h-6 w-6" />,
  //   component: <ViewEntities />,
  //   secondary: true,
  //   show: true,
  // },
  // {
  //   name: "Create Report",
  //   layout: "/admin",
  //   path: "create-report",
  //   icon: <IoMdOptions className="h-6 w-6" />,
  //   component: <CreateReport />,
  //   secondary: true,
  //   show: true,
  // },
  // {
  //   name: "View Report",
  //   layout: "/admin",
  //   path: "View-report",
  //   icon: <TbEyeCheck className="h-6 w-6" />,
  //   component: <ViewReportTable />,
  //   secondary: true,
  //   show: true,
  // },
  // {
  //   name: "Edit Entity",
  //   layout: "/admin",
  //   path: "edit-entity",
  //   icon: <RiEdit2Line className="h-6 w-6" />,
  //   component: <EditEntity />,
  //   secondary: true,
  //   show: false,
  // },
  // {
  //   name: "Edit Report",
  //   layout: "/admin",
  //   path: "edit-report",
  //   icon: <RiEdit2Line className="h-6 w-6" />,
  //   component: <EditReport />,
  //   secondary: true,
  //   show: false,
  // },
  // {
  //   name: "User List",
  //   layout: "/admin",
  //   path: "user-list",
  //   icon: <RiEdit2Line className="h-6 w-6" />,
  //   component: <UserList />,
  //   secondary: true,
  //   show: false,
  // },
  // {
  //   name: "Data Tables",
  //   layout: "/admin",
  //   icon: <MdBarChart className="h-6 w-6" />,
  //   path: "data-tables",
  //   component: <DataTables />,
  //   show: false,
  // },
  // {
  //   name: "Accounts",
  //   layout: "/super-admin",
  //   icon: <MdBarChart className="h-6 w-6" />,
  //   path: "accounts",
  //   component: <AccountsList />,
  //   show: true,
  // },
  // {
  //   name: "Accounts",
  //   subname: " Add New Account",
  //   layout: "/super-admin",
  //   icon: <MdBarChart className="h-6 w-6" />,
  //   path: "accounts/add-new-account",
  //   component: <AddNewAccount />,
  //   show: false,
  // },
  // {
  //   name: "Accounts",
  //   subname: "Edit Account",
  //   layout: "/super-admin",
  //   icon: <MdBarChart className="h-6 w-6" />,
  //   path: "accounts/edit-account",
  //   component: <EditAccount />,
  //   show: false,
  // },
  {
    name: "Accounts",
    layout: "/admin",
    icon: <MdBarChart className="h-6 w-6" />,
    path: "accounts",
    component: <AccountsList />,
    show: true,
  },
  {
    name: "Accounts",
    subname: " Add New Account",
    layout: "/admin",
    icon: <MdBarChart className="h-6 w-6" />,
    path: "accounts/add-new-account",
    component: <AddNewAccount />,
    show: false,
  },
  {
    name: "Accounts",
    subname: "Edit Account",
    layout: "/admin",
    icon: <MdBarChart className="h-6 w-6" />,
    path: "accounts/edit-account",
    component: <EditAccount />,
    show: false,
  },
  // {
  //   name: "User Dashboard",
  //   layout: "/user",
  //   path: "dashboard",
  //   icon: <MdHome className="h-6 w-6" />,
  //   component: <MainDashboard />,
  //   show: true,
  // },
  // {
  //   name: "Submit Report",
  //   layout: "/user",
  //   path: "submit-report",
  //   icon: <HiOutlineDocumentReport className="h-6 w-6" />,
  //   component: <SubmitForm />,
  //   show: true,
  // },

  {
    name: "Raise Complaint",
    layout: "/user",
    path: "raise-complaint",
    icon: <GrCompliance className="h-6 w-6" />,
    component: <RaiseComplaint />,
    // secondary: true,
    show: true,
  },
  {
    name: "Edit Complaint",
    subname: "Edit Complaint",
    layout: "/user",
    path: "/complaints/edit-complaints",
    icon: <GrCompliance className="h-6 w-6" />,
    component: <EditComplaint />,
    // secondary: true,
    show: false,
  },
  {
    name: "View Complaint",
    subname: "View Complaint",
    layout: "/user",
    path: "/complaints/view-complaints",
    icon: <GrCompliance className="h-6 w-6" />,
    component: <ViewComplaints />,
    // secondary: true,
    show: false,
  },
  {
    name: "Complaint Management",
    layout: "/user",
    path: "complaints",
    icon: <BsTable className="h-6 w-6" />,
    component: <ComplaintList />,
    // secondary: true,
    show: true,
  },
  {
    name: "Change Password",
    layout: "/user",
    path: "change-password",
    icon: <IoMdOptions className="h-6 w-6" />,
    component: <ChangePassword />,
    // secondary: true,
    show: true,
  },

  // {
  //   name: "Action Form",
  //   layout: "/user",
  //   path: "action-form",
  //   icon: <HiOutlineDocumentReport className="h-6 w-6" />,
  //   component: <ActionForm />,
  //   secondary: true,
  //   show: false,
  // },
  // {
  //   name: "Place Markers",
  //   layout: "/user",
  //   path: "image-marker-form",
  //   icon: <HiOutlineDocumentReport className="h-6 w-6" />,
  //   component: <ImageMarkerForm />,
  //   show: false,
  // },
  // {
  //   name: "View Submitted Reports",
  //   layout: "/user",
  //   path: "view-report",
  //   icon: <TbFileReport className="h-6 w-6" />,
  //   component: <ViewReports />,
  //   show: true,
  // },
  // {
  //   name: "Profile",
  //   layout: "/admin",
  //   path: "profile",
  //   icon: <MdPerson className="h-6 w-6" />,
  //   component: <Profile />,
  //   show: true,
  // },
  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    icon: <MdLock className="h-6 w-6" />,
    component: <SignIn />,
    show: false,
  },
  {
    name: "Register",
    layout: "/auth",
    path: "register",
    icon: <MdLock className="h-6 w-6" />,
    component: <SignUp />,
    show: false,
  },
  {
    name: "Forgot Password",
    layout: "/auth",
    path: "forgot-password",
    icon: <MdLock className="h-6 w-6" />,
    component: <ForgotPassword />,
    show: false,
  },
  {
    name: "Reset Password",
    layout: "/auth",
    path: "reset-password",
    icon: <MdLock className="h-6 w-6" />,
    component: <ResetPassword />,
    show: false,
  },
  {
    name: "Email Verification",
    layout: "/auth",
    path: "email-verification",
    icon: <MdLock className="h-6 w-6" />,
    component: <ResetPassword />,
    show: false,
  },
  {
    name: "Page Not Found",
    layout: "/user",
    path: "page-not-found",
    icon: <MdLock className="h-6 w-6" />,
    component: <ResetPassword />,
    show: false,
  },
];
export default routes;
